"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.def = exports.schema = void 0;
const cid_1 = require("multiformats/cid");
const zod_1 = require("zod");
const cidSchema = zod_1.z
    .any()
    .refine((obj) => cid_1.CID.asCID(obj) !== null, {
    message: 'Not a CID',
})
    .transform((obj) => cid_1.CID.asCID(obj));
exports.schema = {
    cid: cidSchema,
    bytes: zod_1.z.instanceof(Uint8Array),
    string: zod_1.z.string(),
    array: zod_1.z.array(zod_1.z.unknown()),
    map: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    unknown: zod_1.z.unknown(),
};
exports.def = {
    cid: {
        name: 'cid',
        schema: exports.schema.cid,
    },
    bytes: {
        name: 'bytes',
        schema: exports.schema.bytes,
    },
    string: {
        name: 'string',
        schema: exports.schema.string,
    },
    map: {
        name: 'map',
        schema: exports.schema.map,
    },
    unknown: {
        name: 'unknown',
        schema: exports.schema.unknown,
    },
};
//# sourceMappingURL=types.js.map